import JSBI from 'jsbi'

export const FACTORY_ADDRESS = '0xDdA796Dd8F9dcf8c473ba07Bb75b7271257CE17E'

export const INIT_CODE_HASH = '0x5931a364cc3b8f31c7412d3beaf2406987a0c5dde0801d4d53d199d7c14bb0ca'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
